interface SummaryOverviewProps {
  permitType: string | null
  statusLabel: string
}

export function SummaryOverview({
  permitType,
  statusLabel,
}: SummaryOverviewProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between rounded-md border border-orange-200 bg-orange-50 px-4 py-2 text-sm font-semibold">
        <span className="text-orange-700">Permit Status</span>
        <span className="text-orange-800">{statusLabel}</span>
      </div>
      <div className="flex items-center justify-between rounded-md border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold">
        <span className="text-blue-700">Permit Type</span>
        <span className="text-blue-800">{permitType || "Not provided"}</span>
      </div>
    </div>
  )
}
